// const Test = () => import('@/components/business/Test')
const Impact = () => import('@/components/business/Impact')
const ImpactReminders = () => import('@/components/business/ImpactReminders')
const ImpactHistory = () => import('@/components/business/ImpactHistory')
const ForgotPassword = () => import('@/components/ForgotPassword')
const ResetPassword = () => import('@/components/business/ResetPassword')

const GivingStories = () => import('@/components/business/giving-story/list')
const GivingStoriesNew = () => import('@/components/business/giving-story/listNew')
const CreateGivingStory = () => import('@/components/business/giving-story/create')
const CreateGivingStoryNew = () => import('@/components/business/giving-story/createNew')
const EditGivingStory = () => import('@/components/business/giving-story/edit')
const EditGivingStoryNew = () => import('@/components/business/giving-story/editNew')

const AllProject = () => import('@/components/business/AllProject')
const AllProjectOld = () => import('@/components/business/AllProjectOld')
const BusinessListing = () => import('@/components/business/BusinessListing')
const Project = () => import('@/components/business/Project')
const ProjectOld = () => import('@/components/business/ProjectOld')
const BundleProject = () => import('@/components/business/BundleProject')
const BusinessPersonalProfile = () => import('@/components/business/profile/Personal')
const BusinessPersonalProfileNew = () => import('@/components/business/profile/PersonalNew')
const BusinessCompanyProfile = () => import('@/components/business/profile/Company')
const Billing = () => import('@/components/business/Billing')
const BillingPayment = () => import('@/components/business/Billing/membership')
const BillingImpact = () => import('@/components/business/Billing/impact')
const BillingToken = () => import('@/components/business/Billing/token')
const BusinessProfile = () => import('@/components/business/BusinessProfile')

const GivingCart = () => import('@/components/business/giving-cart/GivingCart')
const GivingCartNew = () => import('@/components/business/giving-cart/GivingCartNew')

const PaymentRedirect = () => import('@/components/business/PaymentRedirect')
const PaymentRedirectNew = () => import('@/components/business/PaymentRedirectNew')
const PaymentSuccess = () => import('@/components/business/giving-cart/PaymentSuccess')
const PaymentFailed = () => import('@/components/business/giving-cart/PaymentFailed')
const PaymentCancel = () => import('@/components/business/giving-cart/PaymentCancel')

const GivingWidget = () => import('@/components/business/connect/GivingWidget')
// const MediaKit = () => import('@/components/business/connect/MediaKit')
const MediaKit1 = () => import('@/components/business/connect/MediaKit1')
const MediaKit2 = () => import('@/components/business/connect/MediaKit2')
const MediaKit3 = () => import('@/components/business/connect/MediaKit3')
const MediaKit4 = () => import('@/components/business/connect/MediaKit4')
const MediaKit5 = () => import('@/components/business/connect/MediaKit5')
const ImpactPartnership = () => import('@/components/business/ImpactPartnership')
const ImpactPartnershipB = () => import('@/components/business/ImpactPartnershipB')
const GratitudeCertificate = () => import('@/components/business/connect/GratitudeCertificate')
const Invite = () => import('@/components/business/connect/Invite')
const HiveBuilder = () => import('@/components/business/hives/HiveBuilder')
const MyHive = () => import('@/components/business/hives/MyHive')
const HiveMember = () => import('@/components/business/hives/HiveMember')
const HiveMemberNew = () => import('@/components/business/hives/HiveMemberNew')
const HiveMemberOld = () => import('@/components/business/hives/HiveMemberOld')

const ProjectUpdates = () => import('@/components/business/updates/ProjectUpdates')
const ProjectUpdateDetails = () => import('@/components/business/updates/ProjectUpdateDetails')

const ProfileUpgrade = () => import(/* webpackChunkName: "business-profile-upgrade" */ '@/components/business/profile/Upgrade/Upgrade')
const ProfileUpgradeNew = () => import(/* webpackChunkName: "business-profile-upgrade" */ '@/components/business/profile/Upgrade/UpgradeNew')
const ProfileUpgradeOption = () => import(/* webpackChunkName: "business-profile-upgrade" */ '@/components/business/profile/Upgrade/UpgradeOption')
const ProfileRenewMembership = () => import(/* webpackChunkName: "business-profile-upgrade" */ '@/components/business/profile/Upgrade/RenewMembership')
const TrialProfileUpgrade = () => import(/* webpackChunkName: "business-profile-upgrade" */ '@/components/business/profile/Upgrade/TrialUpgrade')
const ProfileDowngrade = () => import(/* webpackChunkName: "business-profile-upgrade" */ '@/components/business/profile/Downgrade/Downgrade')
const ProfileUpgradeOld = () => import(/* webpackChunkName: "business-profile-upgrade" */ '@/components/business/profile/Upgrade/UpgradeOld')
const ProfileUpgradeCancel = () => import(/* webpackChunkName: "business-profile-upgrade" */ '@/components/business/profile/Upgrade/UpgradeCancel')
const BusinessRegister = () => import('@/components/business/Register')

const JoinTeamMember = () => import('@/components/business/join/TeamMember')
const JoinBusinessMember = () => import('@/components/business/join/JoinBusinessMember')
const JoinBusinessMemberGeniusu = () => import('@/components/business/join/JoinBusinessMemberGeniusu')
const JoinBusinessUser = () => import('@/components/business/join/JoinBusinessUser')
const JoinBusinessOld = () => import('@/components/business/join/joinBusinessUserOld')

const CampaignSettings = () => import(/* webpackChunkName: "business-campaigns" */ '@/components/business/campaigns/CampaignSettings')
const CampaignUpdate = () => import(/* webpackChunkName: "business-campaigns" */ '@/components/business/campaigns/CampaignUpdate')
const CampaignPaymentSuccess = () => import('@/components/business/campaigns/PaymentSuccess')
const Engagement = () => import('@/components/business/engagement/index')
const EngagementUpdate = () => import('@/components/business/engagement/UpdateEngagement')
const EngagementCreate = () => import('@/components/business/engagement/CreateEnagagement')
const PublicPartnersProfile = () => import('@/components/business/profile/Partner')
const ReferAndGetCredit = () => import('@/components/business/ReferGetCredit')
const TokenManagement = () => import('@/components/business/TokenManagement')
const TeamAccountsManagement = () => import('@/components/business/TeamAccountsManagement')
const TeamAccountsManagementNew = () => import('@/components/business/TeamAccountsManagementNew')
// const PaymentSuccess = () => import('@/components/business/giving-cart/PaymentSuccess')
// const PublicGivingCart = () => import('@/components/public/PublicGivingCart')
const PublicGivingCart = () => import('@/components/business/profile/PublicGivingCart')
// const BusinessHomeGuide = () => import('@/components/business/dashboard/HowGuide')
// const Search = () => import('@/components/business/Search')
// const BusinessPersonalProfile = () => import(/* webpackChunkName: "business-profile" */ '@/components/business/profile/Personal')
// const BusinessProfileNotifications = () => import('@/components/business/profile/Notification')
// const ProfileGivingReminders = () => import(/* webpackChunkName: "business-profile-giving" */ '@/components/business/profile/GivingReminders')
// // const ProfileAutomatedGiving = () => import(/* webpackChunkName: "business-profile-giving" */ '@/components/business/profile/AutomatedGiving')
// const ProfileContributionPayments = () => import(/* webpackChunkName: "business-profile-payment-history" */ '@/components/business/profile/ContributionPayments')
// const ProfileMembershipPayments = () => import(/* webpackChunkName: "business-profile-payment-history" */ '@/components/business/profile/MembershipPayments')
// const ProfileTaxClaimStatement = () => import(/* webpackChunkName: "business-profile-payment-history" */ '@/components/business/profile/TaxClaimStatement')
// const ProfileTaxClaimSGStatement = () => import(/* webpackChunkName: "business-profile-payment-history" */ '@/components/business/profile/TaxClaimSGStatement')
// const ProfileUpgradeStatus = () => import(/* webpackChunkName: "business-profile-upgrade" */ '@/components/business/profile/Upgrade/UpgradeStatus')
// const Team = () => import('@/components/business/profile/Team')
// const PasswordReset = () => import('@/components/business/profile/PasswordReset')
// const PublicPersonalProfile = () => import('@/components/business/public-profile/PersonalProfile')
// const PublicPartnersProfile = () => import('@/components/business/public-profile/PartnersProfile')
// const PublicCompanyProfile = () => import('@/components/business/public-profile/CompanyProfile')
// const Share = () => import('@/components/business/Share')
// const Impact = () => import('@/components/business/Impact')
// const GiveNow = () => import('@/components/business/GiveNow')
// const CreateGivingStory = () => import('@/components/business/CreateGivingStory')
// const EditGivingStory = () => import('@/components/business/EditGivingStory')

// const Goals = () => import('@/components/business/goals/Goals')
// const GoalsForm = () => import('@/components/business/goals/Form')
// const ExploreGiving = () => import('@/components/business/ExploreGiving')
// const ProjectUpdatesSupported = () => import(/* webpackChunkName: "business-project-updates" */ '@/components/business/updates/ProjectUpdatesSupported')
// const ProjectUpdatesAll = () => import(/* webpackChunkName: "business-project-updates" */ '@/components/business/updates/ProjectUpdatesAll')
// const ProjectUpdatesLiked = () => import(/* webpackChunkName: "business-project-updates" */ '@/components/business/updates/ProjectUpdatesLiked')
// const HiveCredits = () => import('@/components/business/hives/HiveCredits')
// const MyConnections = () => import('@/components/business/connect/MyConnections')
// const BusinessMembers = () => import('@/components/business/BusinessMembers')
// const CampaignResults = () => import(/* webpackChunkName: "business-campaigns" */ '@/components/business/campaigns/CampaignResults')
// const PaymentCancel = () => import('@/components/business/payments/PaymentCancel')
// const CampaignPaymentCancel = () => import('@/components/business/payments/CampaignPaymentCancel')
// const PaymentFail = () => import('@/components/business/payments/PaymentFail')
// const BusinessRegisterPremium = () => import('@/components/business/RegisterPremium')
// const BusinessRegisterPremiumStatus = () => import('@/components/business/RegisterPremiumStatus')
// const ProfileUpgradeManage = () => import('@/components/business/profile/Upgrade/UpgradeManage')
// // const ProfileUpgradeManageUpdateCard = () => import('@/components/business/profile/Upgrade/UpgradeManageUpdateCard')
// const MyPaymentMethods = () => import('@/components/business/profile/Upgrade/MyPaymentMethods')
// const ProfileUpgradeManageCancel = () => import('@/components/business/profile/Upgrade/UpgradeManageCancel')
// const JoinBusinessGeniusu = () => import('@/components/business/JoinBusinessGeniusu')

export default [
  // {
  //   path: '/test',
  //   name: 'test',
  //   components: {
  //     business: Test
  //   }
  // },
  {
    path: '/impact',
    name: 'impact',
    components: {
      business: Impact
    },
    meta: (route) => ({title: 'Home'})
  },
  {
    path: '/impact-reminders',
    name: 'impact-reminders',
    components: {
      business: ImpactReminders
    },
    meta: (route) => ({title: 'Impact Reminders'})
  },
  {
    path: '/forgot-password/:key',
    name: 'forgot-password',
    components: {
      business: ForgotPassword
    },
    meta: (route) => ({title: 'Forgot Password'})
  },
  { // old 2d working scenario.
    path: '/giving-stories-old',
    name: 'giving-stories-old',
    components: {
      business: GivingStories
    },
    meta: (route) => ({title: 'Recurring Impacts'})
  },
  {
    path: '/giving-stories',
    redirect: 'recurring-impacts'
  },
  { // new 3d working scenario .
    path: '/recurring-impacts',
    name: 'giving-stories',
    components: {
      business: GivingStoriesNew
    },
    meta: (route) => ({title: 'Recurring Impacts'})
  },
  { // old 2d working scenario.
    path: '/create-giving-story-old',
    name: 'create-giving-story-old',
    components: {
      business: CreateGivingStory
    },
    meta: (route) => ({title: 'Create Recurring Impacts'})
  },
  { // new 3d working scenario.
    path: '/create-recurring-impacts',
    name: 'create-recurring-impacts',
    components: {
      business: CreateGivingStoryNew
    },
    meta: (route) => ({title: 'Create Recurring Impacts'})
  },
  { // old 2d working scenario.
    path: '/giving-story-old/:id',
    name: 'edit-giving-story-old',
    components: {
      business: EditGivingStory
    },
    meta: (route) => ({title: 'Update Recurring Impacts'})
  },
  { // new 3d working scenario.
    path: '/recurring-impact/:id',
    name: 'edit-recurring-impact',
    components: {
      business: EditGivingStoryNew
    },
    meta: (route) => ({title: 'Update Recurring Impacts'})
  },
  {
    path: '/view-all-projects',
    name: 'view-all-projects',
    components: {
      business: AllProject
    },
    meta: (route) => ({title: 'Projects'})
  },
  {
    path: '/view-all-projects-old',
    name: 'view-all-projects-old',
    components: {
      business: AllProjectOld
    },
    meta: (route) => ({title: 'Projects'})
  },
  {
    path: '/business-listing',
    name: 'business-listing',
    components: {
      business: BusinessListing
    },
    meta: (route) => ({title: 'Business Listing'})
  },
  {
    path: '/projectdetail/:id',
    name: 'projectdetail',
    components: {
      business: Project
    }
  },
  {
    path: '/projectdetailold/:id',
    name: 'projectdetailold',
    components: {
      business: ProjectOld
    }
  },
  {
    path: '/bundledetail/:id',
    name: 'bundledetail',
    components: {
      business: BundleProject
    }
  },
  { // old 2d working scenario.
    path: '/personal/profile-old/',
    name: 'business.personal.profile.old',
    components: {
      business: BusinessPersonalProfile
    },
    meta: (route) => ({title: 'Personal Profile'})
  },
  { // new 3d working scenario.
    path: '/personal/profile/',
    name: 'business.personal.profile',
    components: {
      business: BusinessPersonalProfileNew
    },
    meta: (route) => ({title: 'Personal Profile'})
  },
  { // old 2d working scenario.
    path: '/billing-details-old',
    name: 'billing-details-old',
    components: {
      business: Billing
    },
    meta: (route) => ({title: 'Company Billing Details'})
  },
  { // new 3d working scenario.
    path: '/billing-details',
    name: 'billing-details',
    components: {
      business: BillingPayment
    },
    meta: (route) => ({title: 'Company Billing Details'})
  },
  {
    path: '/billing-impacts',
    name: 'billing-impacts',
    components: {
      business: BillingImpact
    },
    meta: (route) => ({title: 'Impact Billing Details'})
  },
  {
    path: '/billing-tokens',
    name: 'billing-tokens',
    components: {
      business: BillingToken
    },
    meta: (route) => ({title: 'Token Billing Details'})
  },
  { // old 2d working scnario.
    path: '/giving-cart-old',
    name: 'giving-cart-old',
    components: {
      business: GivingCart
    },
    meta: (route) => ({title: 'Impact Cart'})
  },
  { // new 3d working scenario.
    path: '/giving-cart',
    name: 'giving-cart',
    components: {
      business: GivingCartNew
    },
    meta: (route) => ({title: 'Impact Cart'})
  },
  { // old 2d working scenario.
    path: '/payment-redirect-old/:type/:userToken/:contributionGroupId',
    name: 'payment-redirect-old',
    components: {
      business: PaymentRedirect
    },
    meta: (route) => ({title: 'Payment Redirect'})
  },
  { // new 3d working scenario.
    path: '/payment-redirect/:type/:userToken/:contributionGroupId',
    name: 'payment-redirect',
    components: {
      business: PaymentRedirectNew
    },
    meta: (route) => ({title: 'Payment Redirect'})
  },
  {
    path: '/personal/reset-password',
    name: 'business.personal.reset-password',
    components: {
      business: ResetPassword
    },
    meta: (route) => ({title: 'Reset Password'})
  },
  {
    path: '/payment-success/',
    name: 'payment.success',
    components: {
      business: PaymentSuccess
    },
    meta: (route) => ({title: 'Impact Cart'})
  },
  {
    path: '/payment-failed/',
    name: 'payment.failed',
    components: {
      business: PaymentFailed
    },
    meta: (route) => ({title: 'Impact Cart'})
  },
  {
    path: '/payment-cancelled',
    name: 'cart-payment-cancel',
    components: {
      business: PaymentCancel
    },
    meta: (route) => ({title: 'Impact Cart'})
  },
  {
    path: '/giving-widget',
    name: 'giving-widget',
    components: {
      business: GivingWidget
    },
    meta: (route) => ({title: 'Impact Widgets'})
  },
  {
    path: '/media-kit',
    name: 'media-kit',
    components: {
      business: MediaKit1
    },
    meta: (route) => ({title: 'Media Kit'})
  },
  {
    path: '/media-kit-brand-guideline',
    name: 'media-kit1',
    components: {
      business: MediaKit1
    },
    meta: (route) => ({title: 'Media Kit'})
  },
  {
    path: '/impact-partnership',
    name: 'impact-partnership',
    components: {
      business: ImpactPartnership
    },
    meta: (route) => ({title: 'Impact Partnership'})
  },
  {
    path: '/impact-partnership-b',
    name: 'impact-partnership-b',
    components: {
      business: ImpactPartnershipB
    },
    meta: (route) => ({title: 'Impact Partnership B'})
  },
  {
    path: '/media-kit-visual-elements',
    name: 'media-kit2',
    components: {
      business: MediaKit2
    },
    meta: (route) => ({title: 'Media Kit'})
  },
  {
    path: '/media-kit-sharing-templates',
    name: 'media-kit3',
    components: {
      business: MediaKit3
    },
    meta: (route) => ({title: 'Media Kit'})
  },
  {
    path: '/media-kit-written-content',
    name: 'media-kit4',
    components: {
      business: MediaKit4
    },
    meta: (route) => ({title: 'Media Kit'})
  },
  {
    path: '/useful-resources',
    name: 'media-kit5',
    components: {
      business: MediaKit5
    },
    meta: (route) => ({title: 'Media Kit'})
  },
  {
    path: '/company/profile/',
    name: 'business.company.profile',
    components: {
      business: BusinessCompanyProfile
    },
    meta: (route) => ({title: 'Company Profile'})
  },
  {
    path: '/gratitude-certificate',
    name: 'gratitude-certificate',
    components: {
      business: GratitudeCertificate
    },
    meta: (route) => ({title: 'Gratitude Certificates'})
  },
  {
    path: '/project-updates/list',
    name: 'project-updates.list',
    components: {
      business: ProjectUpdates
    },
    meta: (route) => ({title: 'Worthy Causes and Project Updates'})
  },
  {
    path: '/project-updates/details/:id',
    name: 'project-updates.details',
    components: {
      business: ProjectUpdateDetails
    }
  },
  { // old 2d working scenario.
    path: '/profile/upgrade-old/',
    name: 'profile.upgrade-old',
    components: {
      business: ProfileUpgrade
    },
    meta: (route) => ({title: 'Upgrade/Renew Membership'})
  },
  { // new 3d working scenario.
    path: '/profile/upgrade/',
    name: 'profile.upgrade',
    components: {
      business: ProfileUpgradeNew
    },
    meta: (route) => ({title: 'Upgrade/Renew Membership'})
  },
  { // new 3d working scenario.
    path: '/profile/upgrade-options/',
    name: 'profile.upgradeoptions',
    components: {
      business: ProfileUpgradeOption
    },
    meta: (route) => ({title: 'Upgrade/Renew Membership'})
  },
  { // new 3d working scenario.
    path: '/profile/renew-membership/',
    name: 'profile.renewmembership',
    components: {
      business: ProfileRenewMembership
    },
    meta: (route) => ({title: 'Upgrade/Renew Membership'})
  },
  { // new 3d working scenario.
    path: '/profile/downgrade/',
    name: 'profile.downgrade',
    components: {
      business: ProfileDowngrade
    },
    meta: (route) => ({title: 'Downgrade/Renew Membership'})
  },
  {
    path: '/business-profile/:id',
    name: 'business-profile',
    components: {
      business: BusinessProfile
    },
    meta: (route) => ({title: 'Company/Profile'})
  },
  { // new 3d working scenario.
    path: '/profile/downgrade/',
    name: 'profile.downgrade',
    components: {
      business: ProfileDowngrade
    },
    meta: (route) => ({title: 'Downgrade/Renew Membership'})
  },
  { // old not working scenario.
    path: '/profile/upgrade-old2/',
    name: 'profile.upgradeOld2',
    components: {
      business: ProfileUpgradeOld
    },
    meta: (route) => ({title: 'Upgrade/Renew Membership'})
  },
  {
    path: '/profile/upgrade/cancel',
    name: 'profile.upgrade.cancel',
    components: {
      business: ProfileUpgradeCancel
    },
    meta: (route) => ({title: 'Cancel Membership Auto-Renewal'})
  },
  // trial user uprade
  {
    path: '/profile/upgrade-trial/',
    name: 'profile.upgrade-trial',
    components: {
      business: TrialProfileUpgrade
    },
    meta: (route) => ({title: 'Upgrade/Renew Membership'})
  },
  {
    path: '/invite',
    name: 'invite',
    components: {
      business: Invite
    }
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    components: {
      business: ResetPassword
    },
    meta: (route) => ({title: 'Reset Password'})
  },
  {
    path: '/impact-history/',
    name: 'impact.history',
    components: {
      business: ImpactHistory
    },
    meta: (route) => ({title: 'Impact History'})
  },
  {
    path: '/token-management/',
    name: 'token-management',
    components: {
      business: TokenManagement
    },
    meta: (route) => ({title: 'Token Management'})
  },
  { // old 2d working scenario.
    path: '/team-accounts-management-old',
    name: 'team-accounts-management-old',
    components: {
      business: TeamAccountsManagement
    },
    meta: (route) => ({title: 'Team Accounts Management'})
  },
  { // new 3d working scenario.
    path: '/team-accounts-management',
    name: 'team-accounts-management',
    components: {
      business: TeamAccountsManagementNew
    },
    meta: (route) => ({title: 'Team Accounts Management'})
  },
  {
    path: '/hive-builder',
    name: 'hive-builder',
    components: {
      business: HiveBuilder
    },
    meta: (route) => ({title: 'Hive Builder'})
  },
  {
    path: '/hive/:page_url',
    name: 'my-hive',
    components: {
      business: MyHive
    }
  },
  { // old 2d hive working scenario.
    path: '/hive-member-old',
    name: 'hive-member-old',
    components: {
      business: HiveMember
    },
    meta: (route) => ({title: 'Create Hive Member'})
  },
  { // new 3d hive working scenario
    path: '/hive-member',
    name: 'hive-member',
    components: {
      business: HiveMemberNew
    },
    meta: (route) => ({title: 'Create Hive Member'})
  },
  { // old not working scenario
    path: '/hive-member-old2',
    name: 'hive-member-old2',
    components: {
      business: HiveMemberOld
    },
    meta: (route) => ({title: 'Create Hive Member'})
  },
  {
    path: '/connect',
    name: 'public-business-register-without-code',
    components: {
      business: BusinessRegister
    },
    meta: (route) => ({title: 'Join B1G1 as a Business For Good'})
  },
  {
    path: '/connect/:code',
    name: 'public-business-register',
    components: {
      business: BusinessRegister
    },
    meta: (route) => ({title: 'Join B1G1 as a Business For Good'})
  },
  {
    path: '/join-teammember/:invite',
    name: 'public-join-teammember',
    components: {
      business: JoinTeamMember
    },
    meta: (route) => ({title: 'Join B1G1 as a Team Member'})
  },
  {
    path: '/campaign-settings',
    name: 'campaign-settings',
    components: {
      business: CampaignSettings
    },
    meta: (route) => ({title: 'Giving Campaign'})
  },
  {
    path: '/campaign/update',
    name: 'campaign-update',
    components: {
      business: CampaignUpdate
    },
    meta: (route) => ({title: 'Edit Giving Campaign'})
  },
  {
    path: '/campaign/payment-success',
    name: 'campaign-payment-success',
    components: {
      business: CampaignPaymentSuccess
    },
    meta: (route) => ({title: 'Thank you for your giving'})
  },
  {
    path: '/engagement-tool',
    name: 'engagement-tool',
    components: {
      business: Engagement
    },
    meta: (route) => ({title: 'Enhanced Engagement Tool'})
  },
  {
    path: '/engagement/update/:key',
    name: 'engagement-update',
    components: {
      business: EngagementUpdate
    },
    meta: (route) => ({title: 'Enhanced Engagement Tool'})
  },
  {
    path: '/engagement/add',
    name: 'engagement-create',
    components: {
      business: EngagementCreate
    },
    meta: (route) => ({title: 'Enhanced Engagement Tool'})
  },
  { // old 2d working scenario.
    path: '/sign-up-old',
    name: 'public-join-business-old',
    components: {
      business: JoinBusinessMember
    },
    meta: (route) => ({title: 'Membership Registration'})
  },
  { // new 3d working scenario.
    path: '/sign-up',
    name: 'public-join-business',
    components: {
      business: JoinBusinessUser
    },
    meta: (route) => ({title: 'Membership Registration'})
  },
  { // not working scenario
    path: '/sign-up-old2',
    name: 'public-join-business-old2',
    components: {
      business: JoinBusinessOld
    },
    meta: (route) => ({title: 'Membership Registration'})
  },
  {
    path: '/sign-up-geniusu',
    name: 'public-join-business-geniusu',
    components: {
      business: JoinBusinessMemberGeniusu
    },
    meta: (route) => ({title: 'Membership Registration'})
  },
  {
    path: '/wcu_partner/:id',
    name: 'wcuprofile',
    components: {
      business: PublicPartnersProfile
    }
  },
  {
    path: '/usercart/:key/:type',
    name: 'public_cart',
    components: {
      business: PublicGivingCart
    }
  },
  {
    path: '/refer-a-project',
    name: 'refer-a-project',
    components: {
      business: ReferAndGetCredit
    },
    meta: (route) => ({title: 'Refer a Project'})
  }
  // {
  //   path: '/payment/process',
  //   name: 'public-payment-process',
  //   components: {
  //     business: CampaignPaymentSuccess
  //   }
  // },
  // {
  //   path: '/api/user/usercart/:key/:type',
  //   name: 'public-cart',
  //   components: {
  //     business: PublicGivingCart
  //   }
  // },
  // {
  //   path: '/payment-success/',
  //   name: 'payment.success',
  //   components: {
  //     business: PaymentSuccess
  //   }
  // }
  // {
  //   path: '/search',
  //   name: 'search',
  //   components: {
  //     business: Search
  //   }
  // },
  // {
  //   path: '/goals/edit/:id',
  //   name: 'goals.edit',
  //   components: {
  //     business: GoalsForm
  //   }
  // },
  // {
  //   path: '/goals/create',
  //   name: 'goals.create',
  //   components: {
  //     business: GoalsForm
  //   }
  // },
  // {
  //   path: '/goals/',
  //   name: 'goals',
  //   components: {
  //     business: Goals
  //   }
  // },
  // {
  //   path: '/explore-giving/',
  //   name: 'explore-giving',
  //   components: {
  //     business: ExploreGiving
  //   }
  // },
  // {
  //   path: '/share/',
  //   name: 'share',
  //   components: {
  //     business: Share
  //   }
  // },
  // {
  //   path: '/give-now',
  //   name: 'give-now',
  //   components: {
  //     business: GiveNow
  //   }
  // },
  // {
  //   path: '/impact',
  //   name: 'impact',
  //   components: {
  //     business: Impact
  //   }
  // },
  // {
  //   path: '/profile/upgrade/status/:id',
  //   name: 'profile.upgrade-status',
  //   components: {
  //     business: ProfileUpgradeStatus
  //   }
  // },
  // {
  //   path: '/profile/team/',
  //   name: 'profile.team',
  //   components: {
  //     business: Team
  //   }
  // },
  // {
  //   path: '/profile/giving-reminders/',
  //   name: 'profile.giving_reminders',
  //   components: {
  //     business: ProfileGivingReminders
  //   }
  // },
  // /* {
  //   path: '/personal/automated-giving/',
  //   name: 'profile.automated-giving',
  //   components: {
  //     business: ProfileAutomatedGiving
  //   }
  // }, */
  // {
  //   path: '/personal/tax-claim-statement',
  //   name: 'profile.tax-claim-statement',
  //   components: {
  //     business: ProfileTaxClaimStatement
  //   }
  // },
  // {
  //   path: '/personal/tax-claim-statement-SG',
  //   name: 'profile.tax-claim-statement-sg',
  //   components: {
  //     business: ProfileTaxClaimSGStatement
  //   }
  // },
  // {
  //   path: '/personal/membership-payments',
  //   name: 'profile.membership-payments',
  //   components: {
  //     business: ProfileMembershipPayments
  //   }
  // },
  // {
  //   path: '/personal/contribution-payments',
  //   name: 'profile.contribution-payments',
  //   components: {
  //     business: ProfileContributionPayments
  //   }
  // },
  // {
  //   path: '/personal/notifications/',
  //   name: 'business.profile.notifications',
  //   components: {
  //     business: BusinessProfileNotifications
  //   }
  // },
  // {
  //   path: '/how-guide',
  //   name: 'home.guide',
  //   components: {
  //     business: BusinessHomeGuide
  //   }
  // },
  // {
  //   path: '/project-updates/supported',
  //   name: 'project-updates.supported',
  //   components: {
  //     business: ProjectUpdatesSupported
  //   }
  // },
  // {
  //   path: '/project-updates/liked',
  //   name: 'project-updates.liked',
  //   components: {
  //     business: ProjectUpdatesLiked
  //   }
  // },
  // {
  //   path: '/hive-credits',
  //   name: 'hive-credits',
  //   components: {
  //     business: HiveCredits
  //   }
  // },
  // {
  //   path: '/my-connections',
  //   name: 'my-connections',
  //   components: {
  //     business: MyConnections
  //   }
  // },
  // {
  //   path: '/business-members',
  //   name: 'business-members',
  //   components: {
  //     business: BusinessMembers
  //   }
  // },
  // {
  //   path: '/campaign-results',
  //   name: 'campaign-results',
  //   components: {
  //     business: CampaignResults
  //   }
  // },
  // {
  //   path: '/personal-account-profile/:id',
  //   name: 'personal-account-profile',
  //   components: {
  //     business: PublicPersonalProfile
  //   }
  // },
  // {
  //   path: '/wcu_partner/:id',
  //   name: 'wcuprofile',
  //   components: {
  //     business: PublicPartnersProfile
  //   }
  // },
  // {
  //   path: '/business-account-profile/:id',
  //   name: 'business-account-profile',
  //   components: {
  //     business: PublicCompanyProfile
  //   }
  // },
  // {
  //   path: '/payment/cancel',
  //   name: 'public-payment-cancel',
  //   components: {
  //     business: PaymentCancel
  //   }
  // },
  // {
  //   path: '/campaign/payment/cancel',
  //   name: 'public-payment-cancel',
  //   components: {
  //     business: CampaignPaymentCancel
  //   }
  // },
  // {
  //   path: '/premium',
  //   name: 'public-business-register-premium',
  //   components: {
  //     business: BusinessRegisterPremium
  //   }
  // },
  // {
  //   path: '/premium/status',
  //   name: 'public-business-register-premium-status',
  //   components: {
  //     business: BusinessRegisterPremiumStatus
  //   }
  // },
  //  // {
  //   path: '/reset-password',
  //   name: 'reset-password',
  //   components: {
  //     business: PasswordReset
  //   }
  // },
  // {
  //   path: '/profile/upgrade/manage',
  //   name: 'profile.upgrade.manage',
  //   components: {
  //     business: ProfileUpgradeManage
  //   }
  // },
  // // {
  // //   path: '/profile/upgrade/manage/update-card',
  // //   name: 'profile.upgrade.update-card',
  // //   components: {
  // //     business: ProfileUpgradeManageUpdateCard
  // //   }
  // // },
  // {
  //   path: '/profile/manage/payment-methods',
  //   name: 'profile.payment.methods',
  //   components: {
  //     business: MyPaymentMethods
  //   }
  // },
  // {
  //   path: '/profile/upgrade/manage/cancel',
  //   name: 'profile.upgrade.cancel',
  //   components: {
  //     business: ProfileUpgradeManageCancel
  //   }
  // },
  // {
  //   path: '/join-business-geniusu',
  //   name: 'public-join-business-geniusu',
  //   components: {
  //     business: JoinBusinessGeniusu
  //   }
  // },
  // {
  //   path: '/payment-redirect/:type/:userToken/:contributionGroupId',
  //   name: 'payment-redirect',
  //   components: {
  //     business: PaymentRedirect
  //   }
  // },
  // {
  //   path: '/payment/fail',
  //   name: 'public-payment-fail',
  //   components: {
  //     business: PaymentFail
  //   }
  // }
]



// WEBPACK FOOTER //
// ./src/router/business.js